import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DateTime } from 'luxon';
import { Subject, filter, takeUntil } from 'rxjs';

import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { UserType } from 'app/core/user/user.types';
import { TeamCalendarService } from 'app/modules/teams/calendar/calendar.service';

export interface DialogData {
    data: null | string
}

@Component({
    selector: 'person-status-dialog',
    templateUrl: 'person-status-dialog.html',
    standalone: true,
    imports: [NgClass, NgIf, NgFor, MatIconModule, MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatFormFieldModule, MatInputModule, MatDatepickerModule]
})
export class PersonStatusDialog implements OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    statusList = [];
    selectedStatus = null;
    message = "";
    expiry: DateTime;
    personId = "";
    personStatusId = "";

    constructor(
        public dialogRef: MatDialogRef<PersonStatusDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData,

        private _changeDetectorRef: ChangeDetectorRef,
        private _service: TeamCalendarService,
        private _userService: UserService,
        private authService: AuthService
    ) {
        //this._service.getPersonStatus$
        //    .pipe(takeUntil(this._unsubscribeAll))
        //    .subscribe((data) => {
        //        console.warn(data);

        //        this._changeDetectorRef.markForCheck();
        //    });

        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: UserType) => {
                this.personId = user.personId;
                this.personStatusId = user.personStatusId;
                this.message = user.personStatusComment;
                this.expiry = user.personStatusExpiry ? DateTime.fromISO(user.personStatusExpiry) : null;

                this._service.getPersonStatus()
                    .pipe(takeUntil(this._unsubscribeAll), filter((raw) => raw != null))
                    .subscribe((data) => {
                        this.statusList = data;

                        const status = this.statusList.find(r => r.personStatusId == this.personStatusId);

                        if (status) this.selectStatus(status);

                        this._changeDetectorRef.markForCheck();
                    });
                
                this._changeDetectorRef.markForCheck();
            });
    }

    ngOnDestroy(): void
    {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    selectStatus(status): void {
        if (!status.canSetExpiryDate) this.expiry = null;
        this.selectedStatus = status;
    }

    close(): void {
        this.dialogRef.close();
    }

    save(): void {
        if (this.personId && this.selectedStatus) {
            
            const data = {
                personStatusId: this.selectedStatus.personStatusId,
                personStatusExpiry: this.selectedStatus.canSetExpiryDate && this.expiry ? this.expiry.toISODate() : null,
                personStatusComment: this.message
            };

            this._service.updatePersonStatus(this.personId, data)
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe(() => {
                    this.authService.validate(true)
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((user) => {
                            if (user) {
                                // this.close();
                                this.dialogRef.close(user);
                            }
                        });
                });
        }
    }
}
